import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_ENABLE_VISION_FE_HELLOWORLD = createFcmDetails('enable_vision_fe_helloworld', {
	owner: 'FE Framework',
	description: 'FCM for test pages only',
	import: false,
});
